import axios from "axios";

export default function getCheckoutDetail(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/prife/checkout/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
